import { z } from 'zod';
export const deviceActionSchema = z
    .object({
    action: z.enum(['lock', 'restart', 'shutdown']),
})
    .strict();
export const deviceActionResultSchema = z
    .object({
    status: z.enum(['accepted', 'rejected', 'unknown']),
})
    .strict();
//# sourceMappingURL=device-actions.js.map